import axios from 'axios'
import 'url-search-params-polyfill'
import generateUuid from '../utilities/api/generateUuid'
import constructAvailabilityRange from '../utilities/availability/constructAvailabilityRange'
import _ from 'lodash'
import moment from 'moment'

export const FETCH_DATES_AVAILABLE_BEGIN   = 'FETCH_DATES_AVAILABLE_BEGIN'
export const FETCH_DATES_AVAILABLE_SUCCESS = 'FETCH_DATES_AVAILABLE_SUCCESS'
export const FETCH_DATES_AVAILABLE_FAILURE = 'FETCH_DATES_AVAILABLE_FAILURE'

export const fetchDatesAvailableBegin = () => ({
	type: FETCH_DATES_AVAILABLE_BEGIN
})

export const fetchDatesAvailableSuccess = availability => ({
	type: FETCH_DATES_AVAILABLE_SUCCESS,
	payload: availability
})

export const fetchDatesAvailableErrors = error => ({
	type: FETCH_DATES_AVAILABLE_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchPropertyAvailability(startDate, endDate, hotelCode, roomTypeCode) {
	return (dispatch, getState) => {
		const configData = getState().configData.configuration

		let configProperty = null
		let hotelProvider = Number(process.env.REACT_APP_COMPONENT_PROPERTY_DEFAULT_PROVIDER) || 0

		if (
			configData &&
			configData.hotel &&
			configData.hotel.options &&
			!_.isEmpty(configData.hotel.options.properties)
		) {
			for (const propertyKey in configData.hotel.options.properties) {
				const currentProperty = configData.hotel.options.properties[propertyKey]

				if (String(hotelCode) === String(currentProperty.hotelCode)) {
					configProperty = currentProperty
				}
			}
		}

		const currency = _.get(configProperty, 'defaultCurrency', 'USD')

		// Client ID key used by IPS to pull correct brand data
		let currentClientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			currentClientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		let queriedStartDate = startDate
		let currentDate = moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD')

		if (moment(queriedStartDate).isBefore(moment(currentDate))) {
			queriedStartDate = moment(currentDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
		}

		// URL Params
		let urlParams = {
			adults: 1,
			children: 0,
			clientId: currentClientId,
			currency: currency,
			endDate: endDate,
			exactMatchOnly: false,
			hotelCode: hotelCode,
			hotelProvider: hotelProvider,
			hotelStayOnly: true,
			pricingMethod: 'Average',
			roomTypeCode: roomTypeCode,
			sessionId: generateUuid(),
			startDate:  queriedStartDate,
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		let apiBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/hotel-stay/' + hotelCode + '/calendar?'

		// Combine API URL & formatted urlParams
		const fetchResult = apiBase + fetchQuery.toString()

		// Begin loading and fetch
		dispatch(fetchDatesAvailableBegin())
		return axios.get(fetchResult, {
			headers: {
				Accept: 'application/ld+json',
				'Content-Type': 'application/ld+json'
			}
		})
			.then((response) => {
				// Reduce unnecessary OTA data
				const availResponse = response.data['hydra:member'].map(hotelAvail => {
					return hotelAvail
				})

				// Configure and construct availability VIA util
				const hotelAvailability = constructAvailabilityRange(queriedStartDate, endDate, availResponse, hotelCode)

				// Store reservation in state
				dispatch(fetchDatesAvailableSuccess(hotelAvailability))
			})
			.catch(error => dispatch(fetchDatesAvailableErrors(error)))
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchPropertyAvailability.js